import React from 'react';

import { TreeViewProps } from './TreeView.types';
import * as Styled from './TreeView.styles';

const TreeViewNode: React.FC<TreeViewProps> = ({ nodes, level = 0 }) => {
  return (
    <>
      {nodes.map((node) => (
        <React.Fragment key={node.id}>
          <Styled.TreeView paddingLeft={level * 10}>{node.nazwa}</Styled.TreeView>
          {node.children.length > 0 && <TreeViewNode nodes={node.children} level={level + 1} />}
        </React.Fragment>
      ))}
    </>
  );
};

export const TreeView: React.FC<TreeViewProps> = ({ nodes }) => {
  return (
    <Styled.TreeViewWrapper>
      <TreeViewNode nodes={nodes} />
    </Styled.TreeViewWrapper>
  );
};
